import React from 'react';
import { BannerDesign, BannerProps } from './BannerProps';
import ServicesListBanner from './ServicesListBanner';
import PhotoWideBanner from './PhotoWideBanner';
import ThreeUpBanner from './ThreeUpBanner';
import StripBanner from './StripBanner';
import BundleBanner from './BundleBanner';
import CouponBanner from './CouponBanner';
import LadderBanner from './LadderBanner';
import DueNextBanner from './DueNextBanner';

export type { BannerDesign, BannerProps, CustomerPromotion, CustomerPromotionRow } from './BannerProps';
export { money, sumRows } from './BannerProps';

export const BANNERS: Record<BannerDesign, React.FC<BannerProps>> = {
  'services-list': ServicesListBanner,
  'photo-wide': PhotoWideBanner,
  'three-up': ThreeUpBanner,
  strip: StripBanner,
  bundle: BundleBanner,
  coupon: CouponBanner,
  ladder: LadderBanner,
  'due-next': DueNextBanner,
};

export {
  ServicesListBanner,
  PhotoWideBanner,
  ThreeUpBanner,
  StripBanner,
  BundleBanner,
  CouponBanner,
  LadderBanner,
  DueNextBanner,
};
